import { UserNameItem } from 'modules/user';
import { useSettings } from 'context/SettingsContext';
import type { TaskPayReportRowType } from '@econtractor/types';
import { formatIncomeLocal, formatIncomePrimary } from '../../ReportUsers/model';
import { sumTaskPay } from '../model';

interface ReportByTaskSummaryTableRowProps {
    user: TaskPayReportRowType;
}

const ReportByTaskSummaryTableRow = ({ user }: ReportByTaskSummaryTableRowProps) => {
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isLocalMode = rate === 1;
    const totals = sumTaskPay(user.rows || [], rate);

    return (
        <tr>
            <td className="name">
                <UserNameItem
                    smallMode
                    user={{
                        userName: user.userName,
                        userEmail: user.userEmail,
                        userPicture: user.userPicture || undefined,
                    }}
                />
            </td>
            <td className="count text-end">
                <h6 className="mb-0">{user.rows?.length || 0}</h6>
            </td>
            <td className="income text-end">
                <h6 className="mb-1 text-break">{formatIncomePrimary(totals.amount, rate)}</h6>
                {!isLocalMode && (
                    <p className="text-muted f-12 mb-0 my-1">{formatIncomeLocal(totals.amountRate)}</p>
                )}
            </td>
        </tr>
    );
};

export default ReportByTaskSummaryTableRow;
